import { UserInterest } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<UserInterest>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const userInterestsReducer = createReducer<State, Actions>(initialState, {
  [actions.getUserInterests.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getUserInterests.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getUserInterests.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getUserInterests.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default userInterestsReducer;
